import projectWidgets from "@main/projectWidgets";

const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar por referencia...",
      },
    },
    status: {
      "ui:placeholder": "status",
      "ui:widget": "type-selector",
      "ui:options": {
        label: false,
        configPath: "types.super_orders.status",
      },
    },
  },
  widgets: { ...projectWidgets },
};
const getCustomerFilterUIConfig: any = (type: string) => {
  return filterUIConfig;
};
export default getCustomerFilterUIConfig;
